"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Banner_1 = __importDefault(require("./Banner"));
var MobileBanner_1 = __importDefault(require("./MobileBanner"));
var SignUpForm_1 = __importDefault(require("./SignUpForm"));
var UserBackNotification_1 = __importDefault(require("./UserBackNotification"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var navigation_1 = require("next/navigation");
var swr_hooks_1 = require("@l2p/swr-hooks");
var SignUp = function (props) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var _a = (0, react_1.useState)(true), showForm = _a[0], setShowForm = _a[1];
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var backUrl = searchParams.get('back');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var closeModal = (0, apps_shared_1.useCloseModal)();
    var onClickClose = (0, react_1.useCallback)(function () {
        showForm ? setShowForm(false) : closeModal();
    }, [closeModal, showForm]);
    var backToForm = (0, react_1.useCallback)(function () {
        setShowForm(true);
    }, []);
    var router = (0, navigation_1.useRouter)();
    (0, react_1.useEffect)(function () {
        if ((props === null || props === void 0 ? void 0 : props.isUserWasAuth) && isAuth) {
            if (backUrl)
                return router.replace(backUrl);
            router.replace('/');
        }
    }, [props === null || props === void 0 ? void 0 : props.isUserWasAuth, router, isAuth]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "646px", padding: "0", onClose: onClickClose, saveSize: true },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            Object.keys(breakpoints).length > 0 && !breakpoints.mobile && (react_1.default.createElement(react_1.default.Fragment, null, props.Banner ? react_1.default.createElement(props.Banner, null) : react_1.default.createElement(Banner_1.default, __assign({}, props)))),
            Object.keys(breakpoints).length > 0 && breakpoints.mobile && (react_1.default.createElement(react_1.default.Fragment, null, props.MobileBanner ? (react_1.default.createElement(props.MobileBanner, null)) : (react_1.default.createElement(MobileBanner_1.default, __assign({}, props))))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(ui_components_1.ModalTitle, null, t('signup')),
                showForm ? (react_1.default.createElement(SignUpForm_1.default, { withLabels: props === null || props === void 0 ? void 0 : props.withLabels, welcomeFields: props === null || props === void 0 ? void 0 : props.welcomeFields, authInputMode: props.authInputMode })) : (react_1.default.createElement(UserBackNotification_1.default, { backToForm: backToForm }))))));
};
exports.default = SignUp;
